import SearchBar from "../../components/universal/SearchBar";
import {
  allUsersHeaders,
  APP_USER,
  CHANNEL_ADMIN_ROLE_NAME,
  CHURCH_ADMIN,
  CHURCH_ADMIN_ROLE_NAME,
  CMS_ADMIN,
  CURRICULUM_ADMIN,
  MINISTRY_ADMIN_ROLE_NAME,
  SUPER_ADMIN,
  TESTIMONIAL_ADMIN,
} from "./Constants";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AllUserHooks } from "./hooks/UsersHooks";
import Navbar from "../../components/universal/Navbar";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCMSUserAction,
  getCMSUserAction,
  resyncUserAuth0ProfileAction,
  setAdminUserPasswordAction,
} from "../../store/Users/UsersAction";
import Toastiy from "../../components/universal/Toastiy";
import CustomCarousel from "../../components/universal/CustomCarousel";
import SingleTab from "../../components/universal/SingleTab";
import { useState } from "react";
import { getServerMessage } from "../../utils/apiMessage";
import Eye from "../../assets/icons/eye2.svg";

function AllUsers() {
  // search bar component state with handler
  const [activeTab, setActiveTab] = useState("All");
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    value,
    onChangeSearchBar,
    reloadData,
    setReloadData,
    searchCriteria,
    setSearchCriteria,
    setCurrentPage,
  } = AllUserHooks(activeTab);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.user);
  const loggedInUser = Array.isArray(userInfo) ? userInfo[0] : userInfo;
  const isSuperAdmin = loggedInUser?.roleCode === SUPER_ADMIN;
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [passwordValues, setPasswordValues] = useState({
    password: "",
    confirmPassword: "",
  });
  const [showPasswords, setShowPasswords] = useState({
    password: false,
    confirmPassword: false,
  });


  const fetchAllUsers = (page, limit, searchCriteriaKeys = {}, callbackFn) => {
    let actualSearchCriteria = searchCriteriaKeys;

    if (searchParams.has("filter")) {
      actualSearchCriteria = { ...actualSearchCriteria, active: searchParams.get("filter") };
    }

    const actualActiveTab =
      searchCriteriaKeys?.hasOwnProperty("activeTab") && searchCriteriaKeys?.activeTab
        ? searchCriteriaKeys?.activeTab
        : activeTab;


    if (searchCriteriaKeys?.hasOwnProperty("activeTab")) {
      delete searchCriteriaKeys["activeTab"];
    }

    if (actualActiveTab) {
      switch (actualActiveTab) {
        case "All":
          break;
        case "Super Admin":
          actualSearchCriteria = { ...actualSearchCriteria, roleCode: SUPER_ADMIN };
          break;
        case "CMS Admin":
          actualSearchCriteria = { ...actualSearchCriteria, roleCode: CMS_ADMIN };
          break;
        case "Testimonial Admin":
          actualSearchCriteria = { ...actualSearchCriteria, roleCode: TESTIMONIAL_ADMIN };
          break;
        case "Curriculum Admin":
          actualSearchCriteria = { ...actualSearchCriteria, roleCode: CURRICULUM_ADMIN };
          break;
        case "App Users":
          actualSearchCriteria = { ...actualSearchCriteria, roleCode: APP_USER };
          break;
        case "Church Admins":
          actualSearchCriteria = {
            ...actualSearchCriteria,
            roleCode: CHURCH_ADMIN,
            roleName: CHURCH_ADMIN_ROLE_NAME,
          };
          break;
        case "Channel Admins":
          actualSearchCriteria = {
            ...actualSearchCriteria,
            roleName: CHANNEL_ADMIN_ROLE_NAME,
          };
          break;
        case "Ministry Admins":
          actualSearchCriteria = {
            ...actualSearchCriteria,
            roleName: MINISTRY_ADMIN_ROLE_NAME,
          };
          break;
        default:
          break;
      }
    }


    dispatch(
      getCMSUserAction({
        apiPayloadRequest: {
          page: page,
          limit: limit,
          searchCriteria: actualSearchCriteria,
        },
        callback: (Data) => {
          if (Data?.type === 1) {
            if (callbackFn)
              callbackFn({
                data: Data?.data?.map((d) => ({ ...d, views: d?.views ?? 0 })),
                total: Data?.totalRecords ?? 0,
              });
          } else if (callbackFn) callbackFn({ data: [], total: Data?.totalRecords ?? 0 });
        },
      })
    );
  };

  const handleOpenResetPasswordModal = (row) => {
    setSelectedUser(row);
    setPasswordValues({
      password: "",
      confirmPassword: "",
    });
    setShowPasswords({
      password: false,
      confirmPassword: false,
    });
    setShowResetPasswordModal(true);
  };

  const handleCloseResetPasswordModal = () => {
    setShowResetPasswordModal(false);
    setSelectedUser(null);
    setPasswordValues({
      password: "",
      confirmPassword: "",
    });
    setShowPasswords({
      password: false,
      confirmPassword: false,
    });
  };

  const handleResetPasswordChange = (e) => {
    const { name, value: inputValue } = e.target;
    setPasswordValues((prev) => ({
      ...prev,
      [name]: inputValue,
    }));
  };

  const togglePasswordVisibility = (fieldName) => {
    setShowPasswords((prev) => ({
      ...prev,
      [fieldName]: !prev[fieldName],
    }));
  };

  const handleResyncUserFromAuth0 = (row) => {
    if (!row?.userAuthId) {
      Toastiy("User Auth0 id is not available");
      return;
    }

    dispatch(
      resyncUserAuth0ProfileAction({
        apiPayloadRequest: {
          _id: row?._id,
          userAuthId: row?.userAuthId,
        },
        callback: (res) => {
          if (res?.type === 1) {
            Toastiy("User synced from Auth0 successfully!", 1);
            setReloadData(true);
          } else {
            Toastiy(getServerMessage(res, "Failed to sync user from Auth0"));
          }
        },
      })
    );
  };

  const handleDeleteUser = (row) => {
    if (!row?._id) {
      Toastiy("User id is not available");
      return;
    }

    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${row?.firstName || row?.email || "this user"}?`
    );
    if (!confirmDelete) return;

    dispatch(
      deleteCMSUserAction({
        apiPayloadRequest: {
          _id: row._id,
        },
        callback: (res) => {
          if (res?.type === 1) {
            Toastiy("User deleted successfully!", 1);
            setReloadData(true);
          } else {
            Toastiy(getServerMessage(res, "Failed to delete user"));
          }
        },
      })
    );
  };

  const handleResetPasswordSubmit = () => {
    if (!passwordValues.password || !passwordValues.confirmPassword) {
      Toastiy("Please enter both password fields");
      return;
    }

    if (passwordValues.password !== passwordValues.confirmPassword) {
      Toastiy("Passwords do not match");
      return;
    }

    dispatch(
      setAdminUserPasswordAction({
        apiPayloadRequest: {
          _id: selectedUser?._id,
          userAuthId: selectedUser?.userAuthId,
          newPassword: passwordValues.password,
        },
        callback: (res) => {
          if (res?.type === 1) {
            Toastiy("Password updated successfully!", 1);
            handleCloseResetPasswordModal();
            setReloadData(true);
          } else {
            Toastiy(getServerMessage(res, "Failed to update password"));
          }
        },
      })
    );
  };

  return (
    <div className="App bg-[#191919] h-fit min-h-screen flex p-4">
      <Navbar />
      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full">
          <SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
              <p className=" text-white text-3xl font-medium">Users</p>
              <div className="flex gap-4">
                {/* <Link to={"/allLanguages"}> */}
                {/* <button className="flex items-center gap-16 text-[13px] text-greyish border px-4 py-2 border-greyish bg-blackish rounded-xl">
                  All
                  <HiOutlineFilter />
                </button> */}
                {/* </Link> */}
                <Link to={"/users/add"}>
                  {" "}
                  <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
                    <AiOutlinePlus /> Add CMS User
                  </button>
                </Link>
              </div>
            </div>
            <div className="">
              <CustomTable
                searchFor="Users"
                width={"w-24"}
                // giving extra width to 2nd column
                nthChildWidth={"[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40"}
                nthChildColor={
                  "[&>*:nth-child(2)]:text-greyish [&>*:nth-child(3)]:text-greyish [&>*:nth-child(4)]:text-greyish"
                }
                data={[]}
                headers={allUsersHeaders}
                customDataFetch={true}
                customDataFetchFunction={fetchAllUsers}
                reloadData={reloadData}
                setReloadData={setReloadData}
                updateCustomCurrentPage={setCurrentPage}
                updateCustomSearchCriteria={setSearchCriteria}
                reverseTable={true}
                handleEyeClick={(row) => {
                                    navigate("/users/" + row?._id, {
                    state: { _id: row?._id, userAuthId: row?.userAuthId },
                  });
                }}
                {...(isSuperAdmin
                  ? {
                      handleEditClick: (row) => {
                                                navigate("/users/add", { state: { _id: row?._id } });
                      },
                      handleAuth0SyncClick: handleResyncUserFromAuth0,
                      handleDeleteClick: handleDeleteUser,
                    }
                  : {})}
                handleResetPasswordClick={handleOpenResetPasswordModal}
                heightDesktop={"h-[72vh]"}
                customTabsClickHandler={({
                  e,
                  fetchCustomData,
                  setCurrentPage: setTableCurrentPage,
                  searchCriteria: tableSearchCriteria,
                }) => {
                                    fetchCustomData(1, { ...tableSearchCriteria, activeTab: e.target.value });
                  setTableCurrentPage(1);
                }}
                customTabs={
                  <CustomCarousel
                    className="ml-10"
                    rows={1}
                    cols={5}
                    gapX={12}
                    gapY={0}
                    // easier to pass this array like this rather than separating it
                    completeSliders={[
                      <SingleTab activeTab={activeTab} tab={"All"} />,
                      <SingleTab activeTab={activeTab} tab={"Super Admin"} />,
                      <SingleTab activeTab={activeTab} tab={"CMS Admin"} />,
                      <SingleTab activeTab={activeTab} tab={"Testimonial Admin"} />,
                      <SingleTab activeTab={activeTab} tab={"Curriculum Admin"} />,
                      <SingleTab activeTab={activeTab} tab={"Church Admins"} />,
                      <SingleTab activeTab={activeTab} tab={"Channel Admins"} />,
                      <SingleTab activeTab={activeTab} tab={"Ministry Admins"} />,
                      <SingleTab activeTab={activeTab} tab={"App Users"} />,
                    ]}
                    numberOfCardsShownInSingleSlide={5}
                    handleCardOnClick={(card) => {
                      setActiveTab((prev) => card.props.tab);
                    }}
                    topNext={"top-3"}
                    topPrev={"top-9"}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>
      {showResetPasswordModal && (
        <div className="fixed inset-0 z-[200] bg-black bg-opacity-60 flex items-center justify-center px-4">
          <div className="w-full max-w-md bg-blackishV2 border border-greyish border-opacity-30 rounded-2xl p-6">
            <div className="flex items-center justify-between mb-5">
              <div>
                <p className="text-white text-xl font-semibold">Reset Password</p>
                <p className="text-greyish text-sm mt-1">
                  {selectedUser?.firstName} {selectedUser?.lastName}
                </p>
              </div>
              <button
                type="button"
                className="text-greyish text-sm"
                onClick={handleCloseResetPasswordModal}
              >
                Close
              </button>
            </div>

            <div className="flex flex-col gap-4">
              <div>
                <label className="text-white text-sm block mb-2">Change Password</label>
                <div className="relative">
                  <input
                    type={showPasswords.password ? "text" : "password"}
                    name="password"
                    value={passwordValues.password}
                    onChange={handleResetPasswordChange}
                    className="w-full bg-[#111111] border border-greyish border-opacity-30 rounded-xl px-4 py-3 pr-12 text-white focus:outline-none"
                    placeholder="Enter new password"
                  />
                  <img
                    className="absolute top-1/2 right-4 h-4 -translate-y-1/2 cursor-pointer"
                    src={Eye}
                    alt="Show password"
                    onClick={() => togglePasswordVisibility("password")}
                  />
                </div>
              </div>
              <div>
                <label className="text-white text-sm block mb-2">Confirm Password</label>
                <div className="relative">
                  <input
                    type={showPasswords.confirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={passwordValues.confirmPassword}
                    onChange={handleResetPasswordChange}
                    className="w-full bg-[#111111] border border-greyish border-opacity-30 rounded-xl px-4 py-3 pr-12 text-white focus:outline-none"
                    placeholder="Confirm new password"
                  />
                  <img
                    className="absolute top-1/2 right-4 h-4 -translate-y-1/2 cursor-pointer"
                    src={Eye}
                    alt="Show password"
                    onClick={() => togglePasswordVisibility("confirmPassword")}
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                className="border border-greyish text-greyish rounded-xl px-4 py-2 text-sm"
                onClick={handleCloseResetPasswordModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="border border-yellowish bg-yellowish text-blackish rounded-xl px-4 py-2 text-sm font-semibold"
                onClick={handleResetPasswordSubmit}
              >
                Update Password
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AllUsers;
